import { useConfig } from 'shared/config/ConfigContext';
import type { Filters } from '@/interfaces';
import { addResultPageFiltersToUrl } from '@/lib/utils/queryParamFilterConversions';
import missingHotelImage from '@/static/icons/emptyState.svg';

interface Props {
    filters: Filters;
}

export const NoHotelWarning = ({ filters }: Props) => {
    const { contextPathPP } = useConfig();

    return (
        <div className="text-center mt-64" data-testid="noHotelWarning">
            <h1>404</h1>
            <p>Hotellet du prøver å finne ser ikke ut til å finnes.</p>
            <p>
                Gå <a href={addResultPageFiltersToUrl(`${contextPathPP}/resultat`, filters)}>tilbake til resultatsiden</a> for å se andre
                alternativer.
            </p>
            <img src={missingHotelImage.src} alt="Katt som sitter på en ball" className="mx-auto my-64" />
        </div>
    );
};
